import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row g-4 mb-4" }
const _hoisted_3 = { class: "col-xxl-8" }
const _hoisted_4 = { class: "col-xxl-4" }
const _hoisted_5 = { class: "row g-4" }
const _hoisted_6 = { class: "col-xxl-12 col-md-6" }
const _hoisted_7 = { class: "col-xxl-12 col-md-6" }
const _hoisted_8 = { class: "row g-4 mb-4" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "row g-4 mb-4" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = { class: "row g-4 mb-4" }
const _hoisted_15 = { class: "col-xxl-4 col-md-6" }
const _hoisted_16 = { class: "col-xxl-4 col-md-6" }
const _hoisted_17 = { class: "col-xxl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CryptoStatsPanel = _resolveComponent("CryptoStatsPanel")!
  const _component_PriceMovementChart = _resolveComponent("PriceMovementChart")!
  const _component_TradingVolumeChart = _resolveComponent("TradingVolumeChart")!
  const _component_PortfolioDistributionChart = _resolveComponent("PortfolioDistributionChart")!
  const _component_ProfitLossChart = _resolveComponent("ProfitLossChart")!
  const _component_RiskExposureChart = _resolveComponent("RiskExposureChart")!
  const _component_RecentTransactions = _resolveComponent("RecentTransactions")!
  const _component_LivePriceTracker = _resolveComponent("LivePriceTracker")!
  const _component_TradesPerMonthChart = _resolveComponent("TradesPerMonthChart")!
  const _component_AssetAllocationChart = _resolveComponent("AssetAllocationChart")!
  const _component_GainersLosers = _resolveComponent("GainersLosers")!
  const _component_MarketSentimentIndicatorChart = _resolveComponent("MarketSentimentIndicatorChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CryptoStatsPanel),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PriceMovementChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_TradingVolumeChart)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_PortfolioDistributionChart)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_ProfitLossChart)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_RiskExposureChart)
          ])
        ]),
        _createVNode(_component_RecentTransactions)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_LivePriceTracker),
        _createVNode(_component_TradesPerMonthChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_AssetAllocationChart)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_GainersLosers)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_MarketSentimentIndicatorChart)
      ])
    ])
  ]))
}